export default {
    'press': {
        'text': `<div class="content-caption-box">
                <h3 class="content-caption">Press Inquiries</h3>
            </div>
            <h3 class="content-heading">Press contact and press pack download area</h3>
            <p class="content-text">This area is reserved for press and news agencies who would like further information on the course, the Minto Foundation and materials to use in article and TV. Please <a ui-sref="site.contact">get in contact</a> for further information or comment.
            </p>`,
    }
}


// WEBPACK FOOTER //
// ./client/app/modules/site/press/i18n/en.js